import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '@environments/environment';

export interface NifContribuinte {
  numeroNIF: string;
  nome: string;
  tipoContribuinte: string;
  estadoContribuinte: string;
  regimeIva: string;
  indicadorNaoResidente: string;
}

@Injectable({ providedIn: 'root' })
export class NifService {
  private readonly http = inject(HttpClient);

  lookup(nif: string): Observable<NifContribuinte> {
    return this.http
      .get<any>(`${environment.nifApiUrl}/${encodeURIComponent(nif)}`)
      .pipe(map(r => r.data.data.ObterContribuinte.contribuinte));
  }
}
